// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-screen-container {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: radial-gradient(circle at top, rgba(191, 233, 236, 0.2), transparent 60%), var(--jedi-background);
  font-family: 'Arial', sans-serif;
}

.register-screen-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
}

.register-screen-card {
  position: relative;
  width: min(560px, 94vw);
  background: rgba(22, 22, 22, 0.95);
  border: 1px solid rgba(196, 222, 29, 0.35);
  border-radius: 18px;
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.4);
  overflow: hidden;
}

.register-screen-header {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 24px 12px;
  color: #ffffff;
  text-align: center;
}

.register-screen-back-button {
  position: absolute;
  left: 18px;
  top: 18px;
  border: 1px solid rgba(196, 222, 29, 0.5);
  border-radius: 999px;
  background: transparent;
  color: var(--jedi-green);
  padding: 6px 12px;
  font-weight: 700;
  cursor: pointer;
}

.register-screen-logo-wrapper {
  width: 76px;
  height: 76px;
  border-radius: 999px;
  background: rgba(196, 222, 29, 0.15);
  border: 1px solid rgba(196, 222, 29, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.register-screen-logo {
  width: 62px;
  height: 62px;
  object-fit: contain;
}

.register-screen-header h1 {
  margin: 0;
  font-size: 1.8rem;
  color: var(--jedi-main-title);
}

.register-screen-header p {
  margin: 0;
  opacity: 0.86;
}

.register-screen-form {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  padding: 10px 24px 24px;
}

.register-screen-form label {
  font-size: 0.9rem;
  color: #d6e0e8;
}

.register-screen-form input {
  width: 100%;
  border: 1px solid rgba(196, 222, 29, 0.28);
  background: #111;
  color: #fff;
  border-radius: 12px;
  padding: 11px 14px;
  outline: none;
}

.register-screen-form input:focus {
  border-color: var(--jedi-green);
  box-shadow: 0 0 0 2px rgba(196, 222, 29, 0.18);
}

.register-screen-error {
  background: rgba(255, 95, 95, 0.16);
  border: 1px solid rgba(255, 95, 95, 0.4);
  color: #ffd7d7;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.9rem;
  margin-top: 2px;
}

.register-screen-submit {
  margin-top: 10px;
  border: none;
  border-radius: 12px;
  padding: 14px 16px;
  background: var(--jedi-green);
  color: #20240a;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
}

.register-screen-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.register-screen-footer {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.9rem;
  color: #d6e0e8;
}

.register-screen-link {
  border: none;
  background: transparent;
  color: var(--jedi-green);
  font-weight: 700;
  cursor: pointer;
}

@media (min-width: 800px) {
  .register-screen-form {
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
  }

  .register-screen-form label[for="register-name"],
  .register-screen-form input#register-name,
  .register-screen-form label[for="register-email"],
  .register-screen-form input#register-email,
  .register-screen-error,
  .register-screen-submit,
  .register-screen-footer {
    grid-column: 1 / -1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RegisterScreen.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6GAA6G;EAC7G,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,yCAAyC;EACzC,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;;;;;;;IAOE,mBAAmB;EACrB;AACF","sourcesContent":[".register-screen-container {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 10000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n  background: radial-gradient(circle at top, rgba(191, 233, 236, 0.2), transparent 60%), var(--jedi-background);\r\n  font-family: 'Arial', sans-serif;\r\n}\r\n\r\n.register-screen-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n.register-screen-card {\r\n  position: relative;\r\n  width: min(560px, 94vw);\r\n  background: rgba(22, 22, 22, 0.95);\r\n  border: 1px solid rgba(196, 222, 29, 0.35);\r\n  border-radius: 18px;\r\n  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.4);\r\n  overflow: hidden;\r\n}\r\n\r\n.register-screen-header {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 24px 24px 12px;\r\n  color: #ffffff;\r\n  text-align: center;\r\n}\r\n\r\n.register-screen-back-button {\r\n  position: absolute;\r\n  left: 18px;\r\n  top: 18px;\r\n  border: 1px solid rgba(196, 222, 29, 0.5);\r\n  border-radius: 999px;\r\n  background: transparent;\r\n  color: var(--jedi-green);\r\n  padding: 6px 12px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n\r\n.register-screen-logo-wrapper {\r\n  width: 76px;\r\n  height: 76px;\r\n  border-radius: 999px;\r\n  background: rgba(196, 222, 29, 0.15);\r\n  border: 1px solid rgba(196, 222, 29, 0.4);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.register-screen-logo {\r\n  width: 62px;\r\n  height: 62px;\r\n  object-fit: contain;\r\n}\r\n\r\n.register-screen-header h1 {\r\n  margin: 0;\r\n  font-size: 1.8rem;\r\n  color: var(--jedi-main-title);\r\n}\r\n\r\n.register-screen-header p {\r\n  margin: 0;\r\n  opacity: 0.86;\r\n}\r\n\r\n.register-screen-form {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 8px;\r\n  padding: 10px 24px 24px;\r\n}\r\n\r\n.register-screen-form label {\r\n  font-size: 0.9rem;\r\n  color: #d6e0e8;\r\n}\r\n\r\n.register-screen-form input {\r\n  width: 100%;\r\n  border: 1px solid rgba(196, 222, 29, 0.28);\r\n  background: #111;\r\n  color: #fff;\r\n  border-radius: 12px;\r\n  padding: 11px 14px;\r\n  outline: none;\r\n}\r\n\r\n.register-screen-form input:focus {\r\n  border-color: var(--jedi-green);\r\n  box-shadow: 0 0 0 2px rgba(196, 222, 29, 0.18);\r\n}\r\n\r\n.register-screen-error {\r\n  background: rgba(255, 95, 95, 0.16);\r\n  border: 1px solid rgba(255, 95, 95, 0.4);\r\n  color: #ffd7d7;\r\n  border-radius: 10px;\r\n  padding: 10px 12px;\r\n  font-size: 0.9rem;\r\n  margin-top: 2px;\r\n}\r\n\r\n.register-screen-submit {\r\n  margin-top: 10px;\r\n  border: none;\r\n  border-radius: 12px;\r\n  padding: 14px 16px;\r\n  background: var(--jedi-green);\r\n  color: #20240a;\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.register-screen-submit:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.register-screen-footer {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  font-size: 0.9rem;\r\n  color: #d6e0e8;\r\n}\r\n\r\n.register-screen-link {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--jedi-green);\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n\r\n@media (min-width: 800px) {\r\n  .register-screen-form {\r\n    grid-template-columns: 1fr 1fr;\r\n    column-gap: 12px;\r\n  }\r\n\r\n  .register-screen-form label[for=\"register-name\"],\r\n  .register-screen-form input#register-name,\r\n  .register-screen-form label[for=\"register-email\"],\r\n  .register-screen-form input#register-email,\r\n  .register-screen-error,\r\n  .register-screen-submit,\r\n  .register-screen-footer {\r\n    grid-column: 1 / -1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
